import { render, staticRenderFns } from "./art.vue?vue&type=template&id=c893ab3e&scoped=true"
import script from "./art.vue?vue&type=script&lang=js"
export * from "./art.vue?vue&type=script&lang=js"
import style0 from "./art.vue?vue&type=style&index=0&id=c893ab3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c893ab3e",
  null
  
)

export default component.exports